export interface HomePageTranslations {
  searchPlaceholder: string;
  taglines: string[];
  privacy: string;
  terms: string;
  players: string;
  clubs: string;
  yourFavorites: string;
  noFavorites: string;
  myProfileTitle: string;
  myProfileSubtitle: string;
  scrollForMore: string;
  loginRequired: string;
  loginRequiredMessage: string;
  noResultsFound: string;
  tryDifferentSearch: string;
  auth: {
    welcome: string;
    welcomeMessage: string;
    linkExpired: string;
    linkExpiredMessage: string;
    errorTitle: string;
    errorMessage: string;
  };
}

export const homePageTranslations: Record<'en' | 'fr' | 'de' | 'it', HomePageTranslations> = {
  en: {
    searchPlaceholder: 'Search players or clubs...',
    taglines: [
      'Track your ELO rating',
      'Swiss rankings in real-time',
      'Predict match outcomes',
      'Find players and clubs',
      'Analyze your statistics',
      'Your table tennis hub'
    ],
    privacy: 'Privacy',
    terms: 'Terms',
    players: 'Players',
    clubs: 'Clubs',
    yourFavorites: 'Your Favorites',
    noFavorites: 'No favorites yet. Add players by clicking the heart icon on their profile.',
    myProfileTitle: 'My Profile',
    myProfileSubtitle: 'Your Stats & Performance',
    scrollForMore: 'Scroll down to discover more',
    loginRequired: 'Login Required',
    loginRequiredMessage: 'Sign in to quickly access your profile on all devices, save favorites, and back up your data across platforms.',
    noResultsFound: 'No results found',
    tryDifferentSearch: 'Try a different search term',
    auth: {
      welcome: 'Welcome!',
      welcomeMessage: 'You have successfully signed in.',
      linkExpired: 'Link Expired',
      linkExpiredMessage: 'This sign-in link has expired or was already used. Please request a new one.',
      errorTitle: 'Sign In Error',
      errorMessage: 'Authentication failed'
    }
  },
  fr: {
    searchPlaceholder: 'Cherche des joueurs ou clubs...',
    taglines: [
      'Suis ton classement ELO',
      'Rankings suisses en direct',
      'Prédis tes matchs',
      'Trouve joueurs et clubs',
      'Analyse tes statistiques',
      'Ton hub tennis de table'
    ],
    privacy: 'Confidentialité',
    terms: 'Conditions',
    players: 'Joueurs',
    clubs: 'Clubs',
    yourFavorites: 'Tes Favoris',
    noFavorites: 'Aucun favori pour le moment. Ajoute des joueurs en cliquant sur l\'icône cœur sur leur profil.',
    myProfileTitle: 'Mon Profil',
    myProfileSubtitle: 'Tes Stats & Performance',
    scrollForMore: 'Fais défiler pour découvrir plus',
    loginRequired: 'Connexion requise',
    loginRequiredMessage: 'Connecte-toi pour accéder rapidement à ton profil sur tous tes appareils, sauvegarder tes favoris et synchroniser tes données.',
    noResultsFound: 'Aucun résultat trouvé',
    tryDifferentSearch: 'Essaie un autre terme de recherche',
    auth: {
      welcome: 'Bienvenue !',
      welcomeMessage: 'Tu t\'es connecté avec succès.',
      linkExpired: 'Lien expiré',
      linkExpiredMessage: 'Ce lien de connexion a expiré ou a déjà été utilisé. Demande-en un nouveau.',
      errorTitle: 'Erreur de connexion',
      errorMessage: 'L\'authentification a échoué'
    }
  },
  de: {
    searchPlaceholder: 'Such nach Spielern oder Vereinen...',
    taglines: [
      'Verfolge deine ELO-Wertung',
      'Schweizer Rangliste live',
      'Berechne deine Chancen',
      'Finde Spieler und Vereine',
      'Analysiere deine Statistik',
      'Dein Tischtennis Hub'
    ],
    privacy: 'Datenschutz',
    terms: 'Bedingungen',
    players: 'Spieler',
    clubs: 'Vereine',
    yourFavorites: 'Deine Favoriten',
    noFavorites: 'Noch keine Favoriten. Füge Spieler hinzu, indem du auf das Herzsymbol auf ihrem Profil klickst.',
    myProfileTitle: 'Mein Profil',
    myProfileSubtitle: 'Deine Stats & Performance',
    scrollForMore: 'Scrolle nach unten für mehr',
    loginRequired: 'Anmeldung erforderlich',
    loginRequiredMessage: 'Melde dich an, um auf allen Geräten schnell auf dein Profil zuzugreifen, Favoriten zu speichern und deine Daten zu synchronisieren.',
    noResultsFound: 'Keine Ergebnisse gefunden',
    tryDifferentSearch: 'Versuche einen anderen Suchbegriff',
    auth: {
      welcome: 'Willkommen!',
      welcomeMessage: 'Du hast dich erfolgreich angemeldet.',
      linkExpired: 'Link abgelaufen',
      linkExpiredMessage: 'Dieser Anmeldelink ist abgelaufen oder wurde bereits verwendet. Bitte fordere einen neuen an.',
      errorTitle: 'Anmeldefehler',
      errorMessage: 'Authentifizierung fehlgeschlagen'
    }
  },
  it: {
    searchPlaceholder: 'Cerca giocatori o club...',
    taglines: [
      'Segui il tuo punteggio ELO',
      'Classifiche svizzere live',
      'Prevedi i tuoi risultati',
      'Trova giocatori e club',
      'Analizza le tue statistiche',
      'Il tuo hub ping pong'
    ],
    privacy: 'Privacy',
    terms: 'Termini',
    players: 'Giocatori',
    clubs: 'Club',
    yourFavorites: 'I Tuoi Preferiti',
    noFavorites: 'Nessun preferito ancora. Aggiungi giocatori cliccando sull\'icona del cuore sul loro profilo.',
    myProfileTitle: 'Il Mio Profilo',
    myProfileSubtitle: 'Le Tue Statistiche & Performance',
    scrollForMore: 'Scorri verso il basso per scoprire di più',
    loginRequired: 'Accesso richiesto',
    loginRequiredMessage: 'Accedi per accedere rapidamente al tuo profilo su tutti i dispositivi, salvare i preferiti e sincronizzare i tuoi dati.',
    noResultsFound: 'Nessun risultato trovato',
    tryDifferentSearch: 'Prova un termine di ricerca diverso',
    auth: {
      welcome: 'Benvenuto!',
      welcomeMessage: 'Hai effettuato l\'accesso con successo.',
      linkExpired: 'Link scaduto',
      linkExpiredMessage: 'Questo link di accesso è scaduto o è già stato utilizzato. Richiedine uno nuovo.',
      errorTitle: 'Errore di accesso',
      errorMessage: 'Autenticazione fallita'
    }
  }
};
